import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, AfterViewInit, Renderer2, ElementRef } from '@angular/core';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { DataHelper } from '@helpers/data.helper';
import { DomSanitizer } from '@angular/platform-browser';
import { environment, getBetGeniusLiveTracker } from '@environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { sportRadarWidgetLanguageList } from '@app/constants/sportRadar.constant';
import { DeepValuePipe } from '@pipes/deepValue.pipe';
import { trackerUrl } from '@environments/environment';

declare let SIR: any;

declare global {
  interface Window {
    STATSCOREWidgets: any;
  }
}

@Component({
  selector: 'livetracker-component',
  templateUrl: '../sharedTemplates/livetracker.component.html',
})
export class LiveTrackerComponent implements OnInit, OnDestroy, AfterViewInit {
  deepValue = new DeepValuePipe();

  @Input() eventIdByInput = 0;

  SIROBJ;
  widgetEl;

  event;
  enableBetGeniusTracker = false;

  betgeniustrackerlink: any;
  iframetrackerlink: any;

  eventid = 0;
  private subscriptionsToStopOnDestroy: Subscription[] = [];

  constructor(
    public _DataHelper: DataHelper,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    public _LZ: LocalizationService,
    public _signalService: SignalrServiceLegacy,
    public _dataHelper: DataHelper,
    private _changeDetection: ChangeDetectorRef,
    private domSanitizer: DomSanitizer,
    public dialog: MatDialog,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) {
    this.renderTracker();
  }
  public isTracerMapped = true;
  public lsTrackerWidget;
  subscriberoute;
  subscribesignalr;
  subscribelive;
  subscribeeventdetail;

  _isActiveSignalrConnectionListener: Subscription;
  ngOnInit() {
    this.eventid = this.eventIdByInput;
    this.initialEventDetail();
    this._isActiveSignalrConnectionListener = this._UiHelper.isActiveSignalrConnectionListener.subscribe(state => {
      this.signalLiveConnection(state);
    });
  }

  ngAfterViewInit() {
    this.renderTracker();
    if (environment.tracker_Operator === 'LS_Tracker' && this.eventid && this.eventid !== 0) {
      setTimeout(() => {
        this.renderLSTracker();
      }, 2000);
      this.renderer.listen(this.widgetEl, 'DOMSubtreeModified', event => {
        if (this.widgetEl.innerHTML === 'Widget could not be loaded.') {
          this.isTracerMapped = false;
        }
      });
    }
  }
  signalLiveConnection(state: boolean): void {
    if (state) {
      this.resetSubscriptions();
      this.initialEventDetail();
    } else {
      this.resetSubscriptions();
    }
  }

  initialEventDetail() {
    this.resetSubscriptions();

    //If connection is not exists
    if (!this._signalService.connectionExists) {
      this.subscribesignalr = this._signalService.connectionEstablished.subscribe(x => {
        this.subscribeHub();
      });
    } else {
      this.subscribeHub();
    }

    this._UiHelper.setNavbarTitle('LIVE');
  }

  iframesrc;
  flagSIR = false;
  subscribeHub() {
    //Signalr Subscription
    if (this.eventid != 0) {
      this._signalService.subscribeLiveEvent(this.eventid);
    }

    this.renderTracker();

    this.subscribelive = this._dataHelper.liveDataListener.subscribe(y => {
      this.event = y.find(x => x.EventId == this.eventid);
      this._changeDetection.detectChanges();

      this.renderTracker();
    });
    if (environment.tracker_Operator === 'LS_Tracker' && this.eventid && this.eventid !== 0) {
      this.renderLSTracker(this.eventid);
    }
  }

  element;
  renderLSTracker(eventId?) {
    if (eventId == undefined) {
      eventId = this.eventid;
    }
    const groupId = environment.tracker_GroupId;
    const inputData = { eventId: `m:${eventId}`, language: 'en', providerId: environment.tracker_ProviderId };
    if (eventId.toString().includes('-')) {
      inputData.eventId = `m:${eventId.toString().split('-')[1]}`;
      inputData.providerId = 109;
    }
    const options = {};
    const widget = new window.STATSCOREWidgets.WidgetGroup(this.element, groupId, inputData, options);
    this.lsTrackerWidget = widget;
  }

  languageWidget(): void {
    SIR('changeLanguage', this.deepValue.transform(sportRadarWidgetLanguageList, [[this._LZ.LANGCODE], 'isoCode']) || 'en');
  }

  renderTracker() {
    if (this._dataHelper.liveData != undefined && !this.flagSIR) {
      this.flagSIR = true;
      this.event = this._dataHelper.liveData.find(x => x.EventId == this.eventid);
      try {
        if (SIR != undefined) {
          if (this.event != undefined && this.event.BetradarMatchId > 0) {
            this.SIROBJ = SIR('addWidget', '.sr-widget-1', 'match.lmtPlus', { layout: 'double', collapseTo: 'disable', pitchLogo: '', matchId: this.event.BetradarMatchId });
            this.languageWidget();
            if (this.SIROBJ) {
              this.enableBetGeniusTracker = false;
            } else {
              this.flagSIR = false;
            }
          } else {
            if (this.event != undefined) {
              this.betgeniustrackerlink = this.domSanitizer.bypassSecurityTrustResourceUrl(getBetGeniusLiveTracker(this.event.BetradarMatchId, this._LZ.LANGCODE));

              this.enableBetGeniusTracker = true;
              this.SIROBJ = SIR('removeWidget', '.sr-widget-1');
              this.languageWidget();
            } else {
              this.flagSIR = false;
            }
          }
        }
      } catch (e) {
        this.flagSIR = false;
        if (this.event != undefined && !this.iframesrc) {
          this.iframesrc = this.domSanitizer.bypassSecurityTrustResourceUrl(`${trackerUrl}/tracker.html?e=` + this.event.BetradarMatchId);
        }
      }
    }
  }

  ngOnDestroy() {
    this.flagSIR = false;
    if (this.subscriberoute != undefined) {
      try {
        this.subscriberoute.unsubscribe();
      } catch (e) {
        console.log(e);
      }
    }

    if (this._isActiveSignalrConnectionListener) {
      this._isActiveSignalrConnectionListener.unsubscribe();
    }

    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
    this.resetSubscriptions();

    if (this.lsTrackerWidget && this.lsTrackerWidget.destroy) {
      try {
        this.lsTrackerWidget.destroy();
      } catch (e) {
        console.log(e);
      }
    }
    if (this.SIROBJ) {
      try {
        SIR('removeWidget', '.sr-widget-1'); // Veya hangi seçici veya parametreler kullanıldıysa
        this.SIROBJ = null;
      } catch (e) {
        console.error('SIR widget temizlenirken hata oluştu:', e);
      }
    }
  }

  resetSubscriptions() {
    this.SIROBJ = null;
    this._signalService.unSubscribeLiveEvent(this.eventid);
    try {
      if (this.subscribesignalr != undefined) {
        this.subscribesignalr.unsubscribe();
      }

      if (this.subscribelive != undefined) {
        this.subscribelive.unsubscribe();
      }

      if (this.subscribeeventdetail != undefined) {
        this.subscribeeventdetail.unsubscribe();
      }
    } catch (e) {
      console.log(e);
    }
  }

  protected readonly Boolean = Boolean;
}
